import axios from "axios";
import TableComponent from "../../../components/common/TableComponent";
import PagePagination from "../../../components/PagePagination";
import { useEffect, useState } from "react";
import localize from "../../../common/localize";
import { generateNoDataValues } from "../../../common/utils";
import ValueOrNoDataLabel from "../../../components/common/ValueOrNoDataLabel";
import useGlobalContext from "../../../hooks/useGlobalContext";
import LoadingPanel from "../../../components/common/LoadingPanel";
import ActionButtons from "../../../components/common/ActionButtons";
import ModalBackground from "../../../components/common/ModalBackground";
import AddOrEditSupply from "./AddOrEditSupply";
import { Box } from "@mui/material";

export default function SuppliesOnWarehouse({ warehouse, filtering }) {
  const [isLoading, setIsLoading] = useState(false);
  const [supplyModel, setSupplyModel] = useState(undefined);
  const { WAREHOUSE_ENDPOINT, config } = useGlobalContext();
  const [supplyData, setSupplyData] = useState(undefined);
  const [pageIndexSupply, setPageIndexSupply] = useState(0);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const getSupplies = async () => {
    try {
      setIsLoading(true);
      const result = await axios.get(
        `${WAREHOUSE_ENDPOINT}/${warehouse?.Id}/supplies`,
        {
          ...config,
          headers: {
            ...config.headers,
            pagination: pageIndexSupply,
            Filter: filtering
              ? JSON.stringify([
                  ...filtering,
                  {
                    Name: "Warehouse",
                    Value: warehouse.Id + "",
                    FilterValue: { Value: warehouse.Id + "" },
                  },
                ])
              : null,
          },
        }
      );

      setSupplyData(result?.data);
    } catch (Exception) {
      console.error(
        `Error loading supplies on warehouse: ${warehouse.Id} - ${warehouse.Name}`,
        Exception
      );
    } finally {
      setIsLoading(false);
    }
  };

  const getColumnTitles = () => {
    return [
      localize.code,
      localize.name,
      localize.quantity,
      localize.measurement_unit,
      localize.provider,
    ];
  };

  useEffect(() => {
    getSupplies();
  }, [pageIndexSupply, filtering]);

  return isLoading ? (
    <LoadingPanel donotUseHscreen />
  ) : (
    <Box>
      {showDetailModal && (
        <ModalBackground
          isDrawerMode
          showModal={showDetailModal}
          setShowModal={setShowDetailModal}
          title={localize.edit_supply}
          hideSubmitButton
          onClickToCancel={() => {
            setShowDetailModal(false);
            setSupplyModel(undefined);
          }}
          cancelButtonText={localize.close}
          Component={
            <AddOrEditSupply
              model={supplyModel}
              setModel={setSupplyModel}
              readOnly
              isWarehouseView
              warehouse={warehouse}
            />
          }
        />
      )}

      <TableComponent
        firstColumnTitle={localize.actions}
        pagination={
          <PagePagination
            pageIndex={pageIndexSupply}
            setPageIndex={setPageIndexSupply}
            dataArray={supplyData}
          />
        }
        columnTitles={getColumnTitles()}
        results={
          supplyData?.Data?.length > 0
            ? supplyData?.Data?.map((item) => ({
                key: item.Id,
                data: [
                  <ActionButtons
                    hideDeleteButton
                    hideEditButton
                    detailsButtonText={localize.details}
                    onClickForDetailButton={() => {
                      setSupplyModel({
                        ...item.SupplyElement,
                        Quantity: item.Quantity,
                      });
                      setShowDetailModal(true);
                    }}
                  />,
                  <ValueOrNoDataLabel data={item.SupplyElement.Code} />,
                  <ValueOrNoDataLabel data={item.SupplyElement.Name} />,
                  item.Quantity,
                  <ValueOrNoDataLabel
                    data={
                      item.SupplyElement.Unit?.Symbol &&
                      item.SupplyElement.Unit?.Symbol !== ""
                        ? `${item.SupplyElement.Unit?.Name} (${item.SupplyElement.Unit?.Symbol})`
                        : `${item.SupplyElement.Unit?.Name}`
                    }
                  />,
                  <ValueOrNoDataLabel
                    data={item.SupplyElement.Provider?.Name}
                  />,
                ],
              }))
            : [generateNoDataValues(5)]
        }
      />
    </Box>
  );
}
